import { useRef } from 'react';
import { isEqual } from 'lodash';
import { useWatch } from 'react-hook-form';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';

type Output = Record<string, unknown>;

const useWatchFields = (fields: string[]): Output => {
  const {
    formMethods,
  } = useQuestionnaireContext();

  const previousValueRef = useRef<Record<string, unknown>>({});
  const watchedValues = useWatch({
    control: formMethods.control,
    name: fields,
  });

  const watchedFields = fields.reduce((acc, key, index) => {
    const value = watchedValues[index];
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, unknown>);

  if (!isEqual(watchedFields, previousValueRef.current)) {
    previousValueRef.current = watchedFields;
  }
  return previousValueRef.current;
};

export default useWatchFields;
